import { createFileRoute, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { History, Stethoscope } from "lucide-react";
import { fetchEntryNodes } from "@/faults-app/lib/db";
import { AppShell } from "@/faults-app/components/app-shell";
import { faultIcon } from "@/faults-app/components/electric-icons";

export const Route = createFileRoute("/history")({
  head: () => ({
    meta: [
      { title: "سجل التشخيص - فاحص الأعطال الكهربائي" },
      {
        name: "description",
        content: "استعرض مسارات التشخيص المتاحة وأعد فتح أي فحص كهربائي سبق أن بدأته.",
      },
      { property: "og:title", content: "سجل التشخيص" },
      { property: "og:description", content: "مسارات التشخيص الكهربائي المتاحة للفني." },
    ],
  }),
  component: HistoryPage,
});

function HistoryPage() {
  const { data: entries = [] } = useQuery({ queryKey: ["entries"], queryFn: fetchEntryNodes });

  return (
    <AppShell>
      <main className="mx-auto w-full max-w-3xl px-4 pt-6">
        <header className="rounded-3xl panel-dark p-5 shadow-card">
          <h1 className="flex items-center gap-2 text-xl font-extrabold text-white">
            <History className="h-6 w-6 text-primary" /> سجل التشخيص
          </h1>
          <p className="mt-1 text-sm text-white/80">
            كل مسارات الفحص المتاحة في البرنامج — اضغط أي مسار لإعادة التشخيص من البداية.
          </p>
        </header>

        <ul className="mt-4 grid gap-3">
          {entries.map((n) => {
            const Ico = faultIcon(n.title_ar ?? n.question_ar);
            return (
              <li key={n.id}>
                <Link
                  to="/diagnose"
                  search={{ node: n.node_key }}
                  className="card-tech press flex items-center gap-3 p-4"
                >
                  <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-accent text-accent-foreground">
                    <Ico className="h-6 w-6" />
                  </span>
                  <span className="min-w-0 flex-1 font-bold">{n.title_ar ?? n.question_ar}</span>
                  <Stethoscope className="h-5 w-5 shrink-0 text-primary-dark" />
                </Link>
              </li>
            );
          })}
        </ul>
      </main>
    </AppShell>
  );
}
